import { z } from 'zod';

export const communityEventSchema = z.object({
  id: z.string(),
  title: z.string(),
  description: z.string(),
  date: z.string(),
  startTime: z.string(),
  endTime: z.string(),
  location: z.string(),
  organizer: z.string(),
  attendees: z.number().int().nonnegative(),
  maxAttendees: z.number().int().positive().optional(),
  image: z.string().optional(),
  category: z.enum(['Social', 'Fitness', 'Meeting', 'Other'] as const),
  status: z.enum(['Upcoming', 'Past', 'Cancelled'] as const),
  price: z.number().optional(),
  isOfficial: z.boolean().optional(),
});

export type CommunityEventDto = z.infer<typeof communityEventSchema>;
